export const getImageAspectRatio = (
  imageUrl?: string | null
): Promise<number | undefined> => {
  return new Promise((resolve) => {
    if (!imageUrl) {
      resolve(undefined);
      return;
    }

    if (typeof window === "undefined") {
      resolve(undefined);
      return;
    }

    const image = new window.Image();

    const cleanup = () => {
      image.onload = null;
      image.onerror = null;
    };

    image.onload = () => {
      cleanup();

      if (!image.naturalWidth || !image.naturalHeight) {
        resolve(undefined);
        return;
      }

      resolve(image.naturalWidth / image.naturalHeight);
    };

    image.onerror = () => {
      cleanup();
      resolve(undefined);
    };

    image.src = imageUrl;
  });
};

